import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ApiWorkflowDialogProps } from '../types';

export const SuccessCountdownMessage: React.FC<
  Pick<
    ApiWorkflowDialogProps,
    | 'onClose'
    | 'successCountdownTime'
    | 'hideDisplayButtonsOnSuccess'
    | 'onRedirectAfterSubmit'
    | 'dialogMessages'
  >
> = ({
  successCountdownTime = 3,
  hideDisplayButtonsOnSuccess,
  dialogMessages,
  onClose,
  onRedirectAfterSubmit,
}) => {
  const [countDown, setCountDown] = useState(successCountdownTime || 3);
  const showMessage = successCountdownTime && hideDisplayButtonsOnSuccess;

  useEffect(() => {
    if (showMessage && countDown > 0) {
      const interval = setInterval(() => {
        setCountDown((prevCount) => prevCount - 1);

        if (countDown === 1) {
          clearInterval(interval);
          if (onRedirectAfterSubmit) onRedirectAfterSubmit();
          else if (onClose) onClose();
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [countDown, onClose, onRedirectAfterSubmit, showMessage]);

  //  Show message if countdown is set and button is hidden
  if (!showMessage) return null;

  return (
    <Typography variant="body2" style={{ fontSize: '12px' }}>
      {dialogMessages?.setSuccessCountdownMessage?.(countDown) ||
        dialogMessages?.successCountdownMessage ||
        `This window will close automatically in ${countDown} seconds.`}
    </Typography>
  );
};
